import * as React from "react";
const SvgRefresh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill="#2466EA"
      fillRule="evenodd"
      d="M3.913 3.18A6.667 6.667 0 0 1 8.5 1.335a6.667 6.667 0 0 1 6.667 6.667.667.667 0 0 1-1.334 0 5.333 5.333 0 0 0-9.186-3.667h1.6a.667.667 0 0 1 0 1.333h-3a.667.667 0 0 1-.667-.666V2a.667.667 0 0 1 1.333 0v1.18Zm6.84 7.16h3.02c.358.011.643.303.647.66v3a.667.667 0 0 1-1.333 0v-1.18A6.667 6.667 0 0 1 1.833 8a.667.667 0 0 1 1.334 0 5.333 5.333 0 0 0 9.186 3.674h-1.6a.667.667 0 0 1 0-1.333Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRefresh;
